import auth from "./AuthApi";

export const login = (params) => {
  return auth.post("auth/login", params);
};

export const register = (params) => {
  return auth.post("auth/register", params);
};

export const resetPassword = (params) => {
  return auth.post("auth/reset-password", params);
};

export const verifyOtp = (params) => {
  return auth.post("auth/verify-otp", params);
};

export const updatePassword = (params) => {
  return auth.post("auth/update-password", params);
};

export const getUser = (params) => {
  return auth.get("users/details?userId=" + params);
};
export const getPlans = () => {
  return auth.get("subscriptions/plan");
};
export const getCredits = (params) => {
  return auth.get("credit/" + params);
};
